import {
  Popover,
  PopoverButton,
  PopoverPanel,
  Transition,
} from '@headlessui/react'
import { Fragment, useState } from 'react'
import { useNavigate } from 'react-router'

interface PopOverProps {
  link?: string
  children: any
}

export default function PopOver({
  link = undefined,
  children = [],
}: PopOverProps) {
  const [isShown, setIsShown] = useState(false)
  const navigate = useNavigate()
  return (
    <Popover
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => {
        setIsShown(false)
      }}
      className="relative h-6 transition-all"
    >
      {link && (
        <PopoverButton onClick={() => navigate(link)}>
          {children[0]}
        </PopoverButton>
      )}
      {!link && <PopoverButton>{children[0]}</PopoverButton>}

      <Transition show={isShown} as={Fragment}>
        <PopoverPanel
          className="absolute z-10"
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
          onFocus={() => setIsShown(true)}
          onBlur={() => setIsShown(false)}
        >
          {children.slice(1)}
        </PopoverPanel>
      </Transition>
    </Popover>
  )
}
